// @flow
import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import type { HeadlineType } from '../Types';
import helpers from '../util/helpers';

import "../css/Headline.css";

type Props = {
  border?: boolean,
  headline: HeadlineType,
  useAvatar: boolean,
  avatarName?: string
};

class Headline extends React.Component<Props> {
  static defaultProps = {
    border: true
  };

  scrollToTips(){
    helpers.eventLog("chemicalPage - jumpToTips");
    let target = document.getElementById('section5_whatcanido')
    // smoothScroll = function(target) {
    var scrollContainer = target;
    do { //find scroll container
        scrollContainer = scrollContainer.parentNode;
        if (!scrollContainer) return;
        scrollContainer.scrollTop += 1;
    } while (scrollContainer.scrollTop == 0);

    var targetY = 0;
    do { //find the top of target relatively to the container
        if (target == scrollContainer) break;
        targetY += target.offsetTop;
    } while (target = target.offsetParent);

    scroll = function(c, a, b, i) {
        i++; if (i > 20) return;
        c.scrollTop = a + (b - a) / 20 * i;
        setTimeout(function(){ scroll(c, a, b, i); }, 20);
    }
    // start scrolling
    scroll(scrollContainer, scrollContainer.scrollTop, targetY, 0);
// }
  }

  render() {

    let highHeadline = false;
    //  version 1: read the priority based on what's set by the researcher in priority_hml
    // if (this.props.headline.priority_hml == "1-high") {highHeadline = true}
    // version 2: read the priority based on a threshold for priorities
    let highPriorityThreshold = 8
    if (this.props.headline.priority <= highPriorityThreshold) {highHeadline = true}

    const avatar = this.props.useAvatar === true && this.props.avatarName !== undefined ? (
      <img src={`/images/${this.props.avatarName}.png`} width='50' alt='Your Avatar' />
    ) : (
      <div />
    )

    return (
      <div className={'headline ' + (highHeadline ? 'high' : 'low')}>
        <div className="headline-adjacent-content">
          {avatar}
          <div>
            <strong>{this.props.headline.contents}</strong>

          </div>
        </div>
        <p onClick={this.scrollToTips}>
          <span className="down-arrow">&darr;</span><em className="what-you-can-do"><FormattedMessage id='what_you_can_do' defaultMessage='Que se puede hacer' /></em><br/>
        </p>
      </div>

    )
  }
}

export default Headline;



// WEBPACK FOOTER //
// ./src/components/Headline.js